import React, { ChangeEvent } from "react";
import classnames from "classnames";

import { FormControlLabel, FormControlMessage } from "..";
import RadioGroup from "./RadioGroup";
import styles from "./RadioGroup.module.scss";
import { RadioVariant } from "./types";

export interface Props {
  name: string;
  value: unknown;
  errorText?: string;
  isError?: boolean;
  wrapperClassName?: string;
  radioButtonClassName?: string;
  variants: RadioVariant[];
  title: React.ReactNode;
  hintText?: string;
  disabled?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, value: unknown) => void;
}

const defaultProps = {
  variants: [],
};

const RadioGroupTable = (props: Props) => {
  const {
    value,
    name,
    variants = defaultProps.variants,
    title,
    hintText,
    errorText,
    isError,
    wrapperClassName,
    radioButtonClassName,
    onChange,
    disabled,
  } = props;

  return (
    <div className={classnames(styles.radioGroupTable, wrapperClassName)}>
      <div key={`radio-row-${title}`} className={styles.radioGroupTableRow}>
        <FormControlLabel
          id={name}
          title={title}
          tooltipText={hintText}
          className={styles.radioGroupTableTitle}
        />
        <RadioGroup
          name={name}
          value={value}
          variants={variants}
          radioButtonClassName={radioButtonClassName}
          inline
          wrapperClassName={styles.radioGroupTableGroup}
          className={styles.radioGroupTableVariants}
          isError={isError}
          isTitleVisible={false}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
      <FormControlMessage
        id={name}
        isError={isError}
        errorText={errorText}
        className={styles.radioGroupTableError}
      />
    </div>
  );
};

export default RadioGroupTable;
